import React, { useState, useMemo } from "react";
import { useInfiniteScroll } from "hooks";

// Components atoms
import Search from "components/atomic/shared/search";
import SelectDateRange from "components/atomic/shared/select-date-range";

// Components molecules
import Tabs from "components/molecules/showing-activity/tabs";

// Components organisms
import FeedTable from "components/organism/showing-activity/feed-table";

// API
import { useGetActivityFeedListInfinite } from "api/showing-activity/query";


const Feed = () => {
  const [limit] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [start, end] = dateRange;

  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const params = {
    _limit: limit,
    ...(searchQuery && { q: searchQuery }),
    ...(start && end && { start_date: formatDate(start), end_date: formatDate(end) }),
  };

  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } = useGetActivityFeedListInfinite({ params });

  const feedData = useMemo(() => {
    return data?.pages?.flatMap(page => page?.data?.data || []) || [];
  }, [data]);

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const handleDateChange = (update) => {
    setDateRange(update);
  };

  const observerTarget = useInfiniteScroll({ hasNextPage, isFetchingNextPage, fetchNextPage });

  return (
    <div className="py-2 px-4 bg-[#FAFAFA]">
      <div className="bg-white rounded-[4px]">
        <div className="px-4 pt-2 flex items-center justify-between gap-2">
          <Tabs />

          <div className="flex items-center gap-2">
            <Search placeholder="Cari marketing dengan nama" onChange={handleSearch} />
            <SelectDateRange startDate={start} endDate={end} onChange={handleDateChange} />
          </div>
        </div>
        <div className="px-4 py-2">
          <FeedTable data={feedData} isLoading={isLoading && !isFetchingNextPage} isSearch={!!searchQuery} />
          
          {isFetchingNextPage && (
            <div className="py-4 text-center">
              <p className="text-[11px] font-inter text-[#808285]">Loading...</p>
            </div>
          )}
          
          {!hasNextPage && feedData.length > 0 && (
            <div className="py-4 text-center">
              <p className="text-[11px] font-inter text-[#808285]">Tidak ada data lagi</p>
            </div>
          )}
          
          <div ref={observerTarget} style={{ height: '20px' }} />
        </div>
      </div>
    </div>
  );
};

export default Feed;
